<template>
  <!--<div id="indexBox">-->
  <!--<el-container class="wmCloudsWrapper">-->
  <!--<app-header></app-header>-->
  <!--<div id="layoutMainMail">-->
  <el-container class="wmCloudsContant">
    <!-- 左侧组织结构个人通讯录 -->
    <!--<app-aside></app-aside>-->
    <el-aside width="201px" class="tableNav nice_scroll">
      <!-- 写信/收信 -->
      <el-row class="flexBetween doubleBtns doubleBtns1">
        <el-button v-show="persAddressPriv" size="small" type="primary" @click="createContact">{{$t("wm_lang_html_267e95")}}</el-button>
      </el-row>
      <!-- 新版本 Tree Aside左侧导航 -->
      <div class="treeAsideSet">
        <!--<el-tree :data="addressTree" icon-class="el-icon-arrow-down" node-key="id" :props="defaultProps" accordion @node-click="handleNodeClick">-->
        <!--<span class="custom-tree-node flexCenter" slot-scope="{ node, data }">-->
        <!--<span class="ellipsis max100 title">{{ node.label }}</span>-->
        <!--</span>-->
        <!--</el-tree>-->
        <TreeView :root="orgTrees" :selector="selector" :enableSelected="false" :clickCallback="nodeClickOrg"/>
        <TreeView v-show="persAddressPriv" :root="persTrees" :selector="selector" :enableSelected="false" :clickCallback="nodeClickPers"/>
      </div>
      <!-- 新建組 -->
      <el-row v-show="persAddressPriv" class="leftEditLink flexCenter">
        <el-link :underline="false" icon="el-icon-circle-plus-outline" :title="$i18n.t('wm_lang_a30c4e')" @click="createGroup"></el-link>
      </el-row>
      <NewGroupDialog v-model="dialogFormVisible" :getGroupAddData="getGroupAddData" :cancelGroupDialog="cancelGroupDialog"
                      ref="newGroupDialog"/>
    </el-aside>
    <el-container>
      <div class="flexbox wmCloudsMain">
        <!--新建联系人-->
        <div class="addressFormBox" v-show="showCreateContact">
          <div class="actionBar flexBetween">
            <div class="actionBarLeft">
              <el-button size="small" type="primary" @click="goBack">{{$t("wm_lang_html_5f4112")}}</el-button>
            </div>
          </div>
          <div class="wmCloudsAddressContant" id="addAddressWrapper">
            <div class="address-form">
              <el-form :model="persForm" :rules="rules" ref="persForm" label-width="180px" size="medium">
                <!-- 二级标题 -->
                <div class="title">
                  <h4>{{$t("wm_lang_html_9e5ffa")}}</h4>
                  <el-divider></el-divider>
                </div>
                <el-form-item :label="$i18n.t('wm_lang_60d045')" prop="givenName" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.givenName"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_3bc5e6')"
                              v-for="(email, index) in persForm.emails"
                              :key="email.key"
                              :prop="'emails.' + index + '.value'"
                              :rules="[
                  { pattern: /^[A-Za-z0-9]+([-_.]\w+)*@[\w-]+(\.[\w-]+)+$/, message: $i18n.t('wm_lang_6a5f04'), trigger: ['blur', 'change'] },
                  { max: 1024, message: $i18n.t('wm_lang_0c686f')+'1024', trigger: 'blur' }
                ]"
                >
                  <el-input v-model="email.value" @blur="emailVerify(email.value, index)"></el-input>
                  <el-link :underline="false" class="add-item" icon="el-icon-circle-plus-outline" :title="$i18n.t('wm_lang_b58c75')" @click="addEmail"></el-link>
                  <el-link :underline="false" class="add-item" icon="el-icon-remove-outline" :title="$i18n.t('wm_lang_2f4aad')" v-if="persForm.emails.length > 1"
                           @click.prevent="removeEmail(email)"></el-link>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_5a93d3')"
                              v-for="(telephone, index) in persForm.telephones"
                              :key="telephone.key"
                              :prop="'telephones.' + index + '.value'"
                              :rules="[
                  { pattern: /^[0-9-()]{1,32}$/, message: $i18n.t('wm_lang_70281d'), trigger: ['blur', 'change'] }
                ]"
                >
                  <el-input v-model="telephone.value"></el-input>
                  <el-link :underline="false" class="add-item" icon="el-icon-circle-plus-outline" :title="$i18n.t('wm_lang_b58c75')"
                           @click="addTelephone"></el-link>
                  <el-link :underline="false" class="add-item" icon="el-icon-remove-outline" :title="$i18n.t('wm_lang_2f4aad')"
                           v-if="persForm.telephones.length > 1" @click.prevent="removeTelephone(telephone)"></el-link>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_4f21b0')"
                              v-for="(fax, index) in persForm.faxs"
                              :key="fax.key"
                              :prop="'faxs.' + index + '.value'"
                              :rules="[
                              { pattern: /^[0-9-()]{1,32}$/, message: $i18n.t('wm_lang_2299ac'), trigger: ['blur', 'change'] }
                            ]"
                >
                  <el-input v-model="fax.value"></el-input>
                  <el-link :underline="false" class="add-item" icon="el-icon-circle-plus-outline" :title="$i18n.t('wm_lang_b58c75')" @click="addFax"></el-link>
                  <el-link :underline="false" class="add-item" icon="el-icon-remove-outline" :title="$i18n.t('wm_lang_2f4aad')" v-if="persForm.faxs.length > 1"
                           @click.prevent="removeFax(fax)"></el-link>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_829abe')" prop="groupIds">
                  <el-checkbox-group v-model="selectedGroupArr">
                    <el-checkbox v-if="index !== 0" v-for="(item, index) in presGroupArr" :label="item.id" :key="index">{{ item.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <!-- 二级标题 -->
                <div class="title">
                  <h4>{{$t("wm_lang_html_5d36f1")}}</h4>
                  <el-divider></el-divider>
                </div>
                <el-form-item :label="$i18n.t('wm_lang_41716f')" prop="company" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.company"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_1e1459')" prop="departName" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.departName"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_b652de')" prop="position" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.position"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_ec84ea')" prop="workWebsite" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.workWebsite"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_e06494')" prop="workAddress">
                  <el-input class="ipt-a" v-model="persForm.workCountry" :placeholder="$i18n.t('wm_lang_ee3f55')"></el-input>
                  <el-input class="ipt-a" v-model="persForm.workProvince" :placeholder="$i18n.t('wm_lang_3d14d1')"></el-input>
                  <el-input class="ipt-a" v-model="persForm.workCity" :placeholder="$i18n.t('wm_lang_371528')"></el-input>
                  <br>
                  <el-input v-model="persForm.workStreet" :placeholder="$i18n.t('wm_lang_716c3d')"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_50a9be')" prop="workPostalCode" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.workPostalCode"></el-input>
                </el-form-item>
                <!-- 二级标题 -->
                <div class="title">
                  <h4>{{$t("wm_lang_html_eab129")}}</h4>
                  <el-divider></el-divider>
                </div>
                <el-form-item :label="$i18n.t('wm_lang_23eb0e')" prop="nickname" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.nickname"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_787b56')" prop="gender" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.gender"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_8483ed')" prop="birthday" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.birthday"></el-input>
                </el-form-item>
                <el-form-item label="QQ" prop="qq" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.qq"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_cfbf6f')" prop="wechat" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.wechat"></el-input>
                </el-form-item>
                <el-form-item label="MSN" prop="msn" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.msn"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_aa8b9d')" prop="homeAddress">
                  <el-input class="ipt-a" v-model="persForm.homeCountry" :placeholder="$i18n.t('wm_lang_ee3f55')"></el-input>
                  <el-input class="ipt-a" v-model="persForm.homeProvince" :placeholder="$i18n.t('wm_lang_3d14d1')"></el-input>
                  <el-input class="ipt-a" v-model="persForm.homeCity" :placeholder="$i18n.t('wm_lang_371528')"></el-input>
                  <br>
                  <el-input v-model="persForm.homeStreet" :placeholder="$i18n.t('wm_lang_716c3d')"></el-input>
                </el-form-item>
                <el-form-item :label="$i18n.t('wm_lang_196ef3')" prop="homePostalCode" :rules="[{ max: 128, message: $i18n.t('wm_lang_0c686f')+'128', trigger: 'blur' }]">
                  <el-input v-model="persForm.homePostalCode"></el-input>
                </el-form-item>
                <!--<el-form-item label=this.$i18n.t('wm_lang_29d8d8')-->
                <!--v-for="(personalRemark, index) in persForm.personalRemark"-->
                <!--:key="personalRemark.key"-->
                <!--:prop="'personalRemark.' + index + '.value'"-->
                <!--&gt;-->
                <!--<el-input v-model="personalRemark.value"></el-input><el-link :underline="false" class="add-item" icon="el-icon-circle-plus-outline" title=this.$i18n.t('wm_lang_b58c75') @click="addPersonalRemark"></el-link><el-link :underline="false" class="add-item" icon="el-icon-remove-outline" title=this.$i18n.t('wm_lang_2f4aad') v-if="persForm.personalRemark.length > 1" @click.prevent="removePersonalRemark(personalRemark)"></el-link>-->
                <!--</el-form-item>-->
                <!-- 二级标题 -->
                <div class="title">
                  <h4>{{$t("wm_lang_html_a86903")}}</h4>
                  <el-divider></el-divider>
                </div>
                <el-form-item :label="$i18n.t('wm_lang_2432b5')" prop="memo" :rules="[{ max: 1024, message: $i18n.t('wm_lang_0c686f')+'1024', trigger: 'blur' }]">
                  <el-input type="textarea" v-model="persForm.memo"></el-input>
                </el-form-item>
                <el-form-item class="submit-button-row">
                  <el-button type="primary" @click="submitFormAdd('persForm')">{{$t("wm_lang_html_939d53")}}</el-button>
                  <el-button @click="resetFormAdd('persForm')">{{$t("wm_lang_html_4b9c32")}}</el-button>
                </el-form-item>
              </el-form>
              <br><br>
            </div>
          </div>
        </div>
        <!--导入-->
        <div class="addressFormBox" v-show="showImport">
          <div class="actionBar flexBetween">
            <div class="actionBarLeft">
              <el-button size="small" type="primary" @click="goBack">{{$t("wm_lang_html_5f4112")}}</el-button>
            </div>
          </div>
          <div class="wmCloudsAddressContant">
            <div class="address-form">
              <el-form ref="importForm" size="medium">
                <!-- 二级标题 -->
                <div class="title">
                  <h4>{{$t("wm_lang_html_6bac4d")}}</h4>
                  <el-divider></el-divider>
                </div>
                <div style="margin-bottom: 20px">{{$t("wm_lang_html_0a25da")}}Outlook{{$t("wm_lang_html_b50566")}}Outlook Express{{$t("wm_lang_html_b50566")}}Foxmail{{$t("wm_lang_html_5b6010")}}CSV{{$t("wm_lang_html_2a2080")}}</div>
                <div style="margin-bottom: 20px">{{$t("wm_lang_html_866bc3")}}CSV{{$t("wm_lang_html_2a2080")}}
                  <el-upload
                      class="upload-csv"
                      action=""
                      multiple
                      :limit="1"
                      :before-upload="handleBeforeUpload"
                      :on-remove="handleRemove"
                      :on-exceed="handleExceed"
                      :http-request="csvUpload"
                      ref="csvUploader"
                      :file-list="csvFileList">
                    <br>
                    <el-button size="small" type="primary">{{$t("wm_lang_html_2c808b")}}</el-button>
                    <br>
                    <div slot="tip" class="el-upload__tip">{{$t("wm_lang_html_2d66a1")}}csv{{$t("wm_lang_html_3b47d7")}}{{ userContactFileMax }}kb</div>
                  </el-upload>
                </div>
                <el-form-item class="pt30">
                  <el-button type="primary" @click="submitFormImport('importForm')">{{$t("wm_lang_html_8d9a07")}}</el-button>
                  <el-button @click="cancelFormImport('importForm')">{{$t("wm_lang_html_625fb2")}}</el-button>
                </el-form-item>
              </el-form>
              <br><br>
            </div>
          </div>
        </div>
        <!--导入详情-->
        <div class="addressFormBox" v-show="showImportDetail">
          <div class="actionBar flexBetween">
            <div class="actionBarLeft">
              <el-button size="small" type="primary" @click="goPrev">{{$t("wm_lang_html_5f4112")}}</el-button>
            </div>
          </div>
          <div class="wmCloudsAddressContant" id="importFieldWrapper">
            <div class="address-form">
              <el-form :model="importDetailForm" ref="importDetailForm" label-width="180px" size="medium" class="form-setting">
                <!-- 二级标题 -->
                <div class="title">
                  <h4>{{$t("wm_lang_html_6bac4d")}}</h4>
                  <el-divider></el-divider>
                </div>
                <div class="mt20 mb20">
                  {{$t("custom_lang_0079")}}
                </div>
                <el-form-item :label="$i18n.t('wm_lang_6aea59')" prop="type">
                  <el-select v-model="importDetailForm.imGroup" :placeholder="$i18n.t('wm_lang_708c9d')" style="max-width:270px;">
                    <el-option v-for="(item, index) in presGroupArr" :label="item.name" :key="index" :value="item.id"
                               style="width:280px;"></el-option>
                  </el-select>
                </el-form-item>
                <!-- 表格 -->
                <div class="mb30">
                  <el-table
                      size="medium"
                      :data="importTableData"
                      style="width: 100%">
                    <el-table-column
                        :label="$i18n.t('wm_lang_faaadc')"
                        width="50">
                      <template slot-scope="scope">
                        <span>{{ scope.row.position + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                        :label="$i18n.t('wm_lang_19eb5b')"
                        width="320">
                      <template slot-scope="scope">
                        <span class="cutout" :title="(scope.row.headerName)">{{ scope.row.headerName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        :label="$i18n.t('wm_lang_f13597')">
                      <template slot-scope="scope">
                        <el-select :placeholder="$i18n.t('wm_lang_708c9d')" v-model="importDetailForm.matchField[scope.row.position]">
                          <el-option :label="$i18n.t('wm_lang_708c9d')" value=""></el-option>
                          <el-option :label="$i18n.t('wm_lang_60d045')" value="givenName"></el-option>
                          <el-option :label="$i18n.t('wm_lang_3bc5e6')" value="email"></el-option>
                          <el-option :label="$i18n.t('wm_lang_5a93d3')" value="telephone"></el-option>
                          <el-option :label="$i18n.t('wm_lang_4f21b0')" value="fax"></el-option>
                          <el-option :label="$i18n.t('wm_lang_41716f')" value="company"></el-option>
                          <el-option :label="$i18n.t('wm_lang_1e1459')" value="departName"></el-option>
                          <el-option :label="$i18n.t('wm_lang_b652de')" value="position"></el-option>
                          <el-option :label="$i18n.t('wm_lang_ec84ea')" value="workWebsite"></el-option>
                          <el-option :label="$i18n.t('wm_lang_41716f')+'-'+$i18n.t('wm_lang_ee3f55')" value="workCountry"></el-option>
                          <el-option :label="$i18n.t('wm_lang_41716f')+'-'+$i18n.t('wm_lang_3d14d1')" value="workProvince"></el-option>
                          <el-option :label="$i18n.t('wm_lang_41716f')+'-'+$i18n.t('wm_lang_371528')" value="workCity"></el-option>
                          <el-option :label="$i18n.t('wm_lang_41716f')+'-'+$i18n.t('wm_lang_716c3d')" value="workStreet"></el-option>
                          <el-option :label="$i18n.t('wm_lang_50a9be')" value="workPostalCode"></el-option>
                          <el-option :label="$i18n.t('wm_lang_23eb0e')" value="nickname"></el-option>
                          <el-option :label="$i18n.t('wm_lang_787b56')" value="gender"></el-option>
                          <el-option :label="$i18n.t('wm_lang_8483ed')" value="birthday"></el-option>
                          <el-option :label="$i18n.t('wm_lang_cfbf6f')" value="wechat"></el-option>
                          <el-option label="QQ" value="qq"></el-option>
                          <el-option label="MSN" value="msn"></el-option>
                          <el-option :label="$i18n.t('wm_lang_622b43')+'-'+$i18n.t('wm_lang_ee3f55')" value="homeCountry"></el-option>
                          <el-option :label="$i18n.t('wm_lang_622b43')+'-'+$i18n.t('wm_lang_3d14d1')" value="homeProvince"></el-option>
                          <el-option :label="$i18n.t('wm_lang_622b43')+'-'+$i18n.t('wm_lang_371528')" value="homeCity"></el-option>
                          <el-option :label="$i18n.t('wm_lang_622b43')+'-'+$i18n.t('wm_lang_716c3d')" value="homeStreet"></el-option>
                          <el-option :label="$i18n.t('wm_lang_196ef3')" value="homePostalCode"></el-option>
                          <el-option :label="$i18n.t('wm_lang_2432b5')" value="memo"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <el-form-item :label="$i18n.t('wm_lang_53d9ef')" prop="type">
                  <el-select v-model="importDetailForm.charset" @change="changeFileCode" :placeholder="$i18n.t('wm_lang_708c9d')">
                    <el-option :label="$i18n.t('wm_lang_18c634')" value=""></el-option>
                    <el-option label="UTF-8" value="utf8"></el-option>
                    <el-option label="GB18030" value="GB18030"></el-option>
                    <el-option label="BIG-5 (HK)" value="Big5-HKSCS"></el-option>
                    <el-option label="Shift-JIS (JP)" value="windows-31j"></el-option>
                    <el-option label="ISO-2022-JP" value="x-windows-iso2022jp"></el-option>
                    <el-option label="ENC-KR" value="x-windows-949"></el-option>
                    <el-option label="ISO-2022-KR" value="ISO-2022-KR"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitFormImportDetail('importDetailForm')">{{$t("wm_lang_html_38cf16")}}</el-button>
                  <el-button @click="cancelFormImportDetail('importDetailForm')">{{$t("wm_lang_html_625fb2")}}</el-button>
                </el-form-item>
              </el-form>
              <br><br>
            </div>
          </div>
        </div>
        <!--列表及内容-->
        <div class="wmCloudsBox" v-show="!showCreateContact && !showImport && !showImportDetail">
          <!-- 操作栏 -->
          <div class="actionBar flexBetween">
            <!-- 左侧 -->
            <div class="actionBarLeft">
              <!-- 全选按钮 -->
              <el-dropdown @command="checkedCommand" size="small" class="actionDropdown">
                <el-button size="small">
                  <el-checkbox v-model="allListCheckBox" @click.native.stop="stopBubble($event)"
                               @change.native="handleAllChecked($event)"></el-checkbox>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                  <el-dropdown-item command="all">{{$t("wm_lang_html_66eeac")}}</el-dropdown-item>
                  <el-dropdown-item command="reverse">{{$t("wm_lang_html_aab57a")}}</el-dropdown-item>
                  <el-dropdown-item command="not">{{$t("wm_lang_html_6297bc")}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button-group class="ml10 actionBtnGroup" v-show="selectedAddress > 0">
                <el-button size="small" @click.native="toWrite">
                  <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_e9e805")}}</span>
                  <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_e9e805')" placement="top">
                    <i class="icon el-icon-message"></i>
                  </el-tooltip>
                </el-button>
              </el-button-group>
              <el-button-group class="ml10 actionBtnGroup" v-show="currAddressType === 'pers' && selectedAddress > 0">
                <el-dropdown split-button trigger="click" size="small" class="actionDropdown">
                  <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_442c6a")}}</span>
                  <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_442c6a')" placement="top">
                    <i class="icon el-icon-user"></i>
                  </el-tooltip>
                  <el-dropdown-menu slot="dropdown" class="el-dropdown-ej p20 nice_scroll ywdh el-dropdown-max210">
                    <el-dropdown-item v-if="index !== 0" v-for="(item, index) in presGroupArr" :key="index">
                      <div class="item" :title="(item.name)" @click.stop="selectGroup($event, item)"><input class="pr--1" type="checkbox"
                                                                                                            :checked="checkedGroup(item.id)"/><span
                          class=" max-auto cutout">{{
                          item.name
                        }}</span>
                      </div>
                    </el-dropdown-item>
                    <div @click="applyGroup" class="p10 footer" style="overflow:hidden;">
                      <el-button size="mini" type="primary" class="float-r">{{$t("wm_lang_html_5b0520")}}</el-button>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button-group>
              <el-button-group class="ml10 actionBtnGroup">
                <el-dropdown split-button size="small" class="actionDropdown" trigger="click">
                  <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_c2fe62")}}</span>
                  <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_c2fe62')" placement="top" trigger="click">
                    <i class="icon el-icon-filtrate"></i>
                  </el-tooltip>
                  <el-dropdown-menu slot="dropdown" class="el-dropdown-ej el-dropdown-ej-max96">
                    <!--                    <el-dropdown-item @click="filterContact('all')">{{$t("wm_lang_html_a8b0c2")}}</el-dropdown-item>-->
                    <el-dropdown-item>{{$t("wm_lang_html_c360e9")}}<i class="el-icon-arrow-right el-icon--right"></i>
                      <div class="el-dropdown-menu-ej">
                        <ul class="el-dropdown-menu">
                          <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'def'}"
                              @click="filterContact('def')">{{$t("custom_lang_0054")}}
                          </li>
                          <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'nameAsc'}"
                              @click="filterContact('nameAsc')">{{$t("custom_lang_0055")}}
                          </li>
                          <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'nameDesc'}"
                              @click="filterContact('nameDesc')">{{$t("custom_lang_0056")}}
                          </li>
                          <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'addrAsc'}"
                              @click="filterContact('addrAsc')">{{$t("custom_lang_0057")}}
                          </li>
                          <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'addrDesc'}"
                              @click="filterContact('addrDesc')">{{$t("custom_lang_0058")}}
                          </li>
                        </ul>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button-group>
              <el-button-group class="ml10 actionBtnGroup" v-show="currAddressType === 'pers' && selectedAddress > 0">
                <el-button size="small" @click.native="deletePerson">
                  <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_2f4aad")}}</span>
                  <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_2f4aad')" placement="top">
                    <i class="icon el-icon-del"></i>
                  </el-tooltip>
                </el-button>
              </el-button-group>
              <el-button-group class="ml10 actionBtnGroup" v-show="currAddressType === 'pers'">
                <el-dropdown split-button size="small" class="actionDropdown">
                  <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_0ec9ea")}}</span>
                  <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_0ec9ea')" placement="top">
                    <span>{{$t("wm_lang_html_0ec9ea")}}</span>
                  </el-tooltip>
                  <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                    <el-dropdown-item v-show="currDepartGroup.id !== 'persRoot' && currDepartGroup.id !== 'def'" @click.native="editGroup">
                      {{$t("wm_lang_9aab18")}}
                    </el-dropdown-item>
                    <el-dropdown-item v-show="currDepartGroup.id !== 'persRoot' && currDepartGroup.id !== 'def'"
                                      @click.native="deleteGroup">{{$t("custom_lang_0060")}}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="addrImport">{{$t("wm_lang_html_8d9a07")}}</el-dropdown-item>
                    <el-dropdown-item @click.native="addrExport">{{$t("wm_lang_html_55405e")}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button-group>
            </div>
          </div>
          <!-- 设置页面包屑导航 -->
          <!--<setBreadNav style="display:none;"></setBreadNav>-->
          <!-- 如下代码需要做判断，如果是首页加homeCloudsCount CLASS；其它页面加wmCloudsCount  CLASS -->
          <div class="flexbox wmCloudsCount homeCloudsCount">
            <!-- 邮件列表 -->
            <!-- 需要做判断，如果是列表显示的代码，在resize-box-main  ClASS  加宽度100% ；左右显示不加-->
            <div class="resize-box-main">
              <!-- 联系人列表 -->
              <div :class="['listBar resize-box']" :style="{ width: dragWidth + 'px' }">
                <div class="maiTxt outfullsearch">
                  <div style="table-layout:fixed;word-break:break-all;">
                    <span v-show="!displaySearch" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;"><span
                        class="title cutout max197 float-l">{{ currDepartGroup.name ? currDepartGroup.name : this.$i18n.t('wm_lang_d3298c') }}</span><span>{{$t("wm_lang_html_58037b")}}{{totalCount}}</span>{{$t("wm_lang_html_465afe")}}</span>
                    <span v-show="displaySearch" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;"><span
                        class="title cutout float-l">{{ currDepartGroup.name ? currDepartGroup.name : this.$i18n.t('wm_lang_d3298c') }} {{$t("wm_lang_html_317a66")}} </span><span> "{{currSearchKey}}" :{{$t("wm_lang_fbd2b1")}}<span class="fwb">{{ totalCount }}</span> </span></span>
                  </div>
                </div>
                <div class="nice_scroll contList">
                  <!-- 循环数据-选中后ul标签上新增 selectBg CLASS；未星标图标点击后新增iconOn CLASS; 未读邮件咋标题和描述div上新增字体加粗fwb CLASS;列举了两条，第一条是选中的样式，第二条默认样式-->
                  <ul :class="checkedItem(item.id) ? 'contListOne mailItem selectBg' : 'contListOne mailItem'"
                      v-for="(item, index) in currentListData" @click="toReadContact(item)">
                    <li class="clear flexBetween">
                      <input type="checkbox" :checked="checkedItem(item.id)" @click.stop="handleCheckedMailChange($event,item)"/>
                      <div class="nameTd cutout max-auto mar f14 p0-p5 fwb" title="">{{ item.name ? item.name : '('+$i18n.t('wm_lang_b7612b')+')' }}</div>
                      <!-- <div class="rightAll"><span class="time" v-if="item.type !== 4">{{item.tel}}</span></div> -->
                    </li>
                    <div class="pl18 mt5 c_blue">
                      <li class="clear flexBetween p0" :title="getDepartsLabel(item.parent ? item.parent : {})">
                        <div class="max-auto cutout">{{ getDepartsLabel(item.parent ? item.parent : {}) }}</div>
                      </li>
                      <li class="clear flexBetween p0" title="">
                        <!--<div class="">{{$t("wm_lang_html_7a3680")}}</div>-->
                        <div class="listTd cutout max-auto">{{ item.email }}</div>
                      </li>
                    </div>
                  </ul>
                  <!-- 无数据 -->
                  <!--<p class="p20" style="display:none;">{{$t("wm_lang_html_918b52")}}</p>-->
                </div>
                <!-- 分页 -->
                <div class="listBarPag flexBetween">
                  <el-dropdown size="medium" trigger="click" class="mr20" @command="handlePageTurn">
                <span class="el-dropdown-link">
                  {{ currentPage }}/{{ totalPages }}页<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                    <el-dropdown-menu slot="dropdown" style="max-height:150px;overflow:auto;" class="nice_scroll">
                      <!--<el-dropdown-item class="active">1/5</el-dropdown-item>-->
                      <el-dropdown-item :command="item.c" v-for="(item, index) in pageNumbers" :key="index">{{ item.c }}/{{ item.t }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-link :underline="false" @click="prevPage"><i
                      :class="getTurnPrevFlag() ? 'el-icon-arrow-left mr10 f18 disabled' : 'el-icon-arrow-left mr10 f18'"></i></el-link>
                  <el-link :underline="false" @click="nextPage"><i
                      :class="getTurnNextFlag() ? 'el-icon-arrow-right mr10 f18 disabled' : 'el-icon-arrow-right mr10 f18'"></i></el-link>
                </div>
              </div>
            </div>

            <!-- 拖拽拉伸按钮 -->
            <dragHolder @widthChange="dragWidthChange"/>
            <!--<div id="drag" class="enabl">-->
            <!--<div class="contListWid">-->
            <!--<p style="background-color: yellow;"><span></span><span></span><span></span></p>-->
            <!--</div>-->
            <!--</div>-->

            <!-- view内容区 -->
            <div class="mainBar nice_scroll">
              <div class="empty adressEmpty2" v-show="selectedAddress <= 0 || currentListData.length === 0">
                <i class="ico ico-adress-noinfo2"></i>{{$t("custom_lang_0039")}}
              </div>
              <div class="empty adressEmpty3" v-show="selectedAddress > 1">
                <i class="ico ico-adress-noinfo3"></i>{{$t("wm_lang_html_543b04")}}&nbsp;<strong>{{ $store.getters.checkedAddress.length }}</strong>&nbsp;{{$t("wm_lang_html_44a2c7")}}
              </div>
              <div class="address-cont" v-show="selectedAddress === 1 && currentListData.length !== 0">
                <ul v-if="$store.getters.currAddressType === 'pers'">
                  <h2 class="name">{{ currPerson.givenName ? currPerson.givenName : '('+$i18n.t('wm_lang_b7612b')+')' }}
                    <el-link :underline="false" class="ml10 f20 add-item" icon="el-icon-edit" :title="$i18n.t('wm_lang_95b351')"
                             v-show="currAddressType === 'pers'" @click="editContact"></el-link>
                  </h2>
                  <li v-if="currPerson.emails && currPerson.emails.toString() !== ''"><span class="title">{{$t("wm_lang_html_da4495")}}</span><span
                      class="tex">{{ currPerson.emails ? currPerson.emails.toString() : '' }}</span></li>
                  <li v-if="currPerson.telephones && currPerson.telephones.toString() !== ''"><span class="title">{{$t("wm_lang_html_c6b4d7")}}</span><span
                      class="tex">{{ currPerson.telephones ? currPerson.telephones.toString() : '' }}</span></li>
                  <li v-if="currPerson.faxs && currPerson.faxs.toString() !== ''"><span class="title">{{$t("wm_lang_html_76b8e6")}}</span><span
                      class="tex">{{ currPerson.faxs ? currPerson.faxs.toString() : '' }}</span></li>
                  <li><span class="title">{{$t("wm_lang_html_f75896")}}</span><span class="tex">{{ displayGroup }}</span></li>
                  <li v-if="currPerson.company"><span class="title">{{$t("wm_lang_html_f6d477")}}</span><span class="tex">{{ currPerson.company }}</span></li>
                  <li v-if="currPerson.departName"><span class="title">{{$t("wm_lang_html_3593a5")}}</span><span class="tex">{{ currPerson.departName }}</span></li>
                  <li v-if="currPerson.position"><span class="title">{{$t("wm_lang_html_2d76b9")}}</span><span class="tex">{{ currPerson.position }}</span></li>
                  <li v-if="currPerson.workWebsite"><span class="title">{{$t("wm_lang_html_fcec0a")}}</span><span
                      class="tex">{{ currPerson.workWebsite }}</span></li>
                  <li v-if="currPerson.workCountry || currPerson.workProvince || currPerson.workCity || currPerson.workStreet"><span
                      class="title">{{$t("wm_lang_html_727725")}}</span><span
                      class="tex">{{ currPerson.workCountry }}{{ currPerson.workProvince }}{{ currPerson.workCity }}{{
                      currPerson.workStreet
                    }}</span>
                  </li>
                  <li v-if="currPerson.workPostalCode"><span class="title">{{$t("wm_lang_html_40ad89")}}</span><span
                      class="tex">{{ currPerson.workPostalCode }}</span></li>
                  <li v-if="currPerson.nickname"><span class="title">{{$t("wm_lang_html_d16180")}}</span><span class="tex">{{ currPerson.nickname }}</span></li>
                  <li v-if="currPerson.gender"><span class="title">{{$t("wm_lang_html_021161")}}</span><span class="tex">{{ currPerson.gender }}</span></li>
                  <li v-if="currPerson.birthday"><span class="title">{{$t("wm_lang_html_456b82")}}</span><span class="tex">{{ currPerson.birthday }}</span></li>
                  <li v-if="currPerson.qq"><span class="title">QQ{{$t("wm_lang_html_dec892")}}</span><span class="tex">{{ currPerson.qq }}</span></li>
                  <li v-if="currPerson.wechat"><span class="title">{{$t("wm_lang_html_da671a")}}</span><span class="tex">{{ currPerson.wechat }}</span></li>
                  <li v-if="currPerson.msn"><span class="title">MSN{{$t("wm_lang_html_dec892")}}</span><span class="tex">{{ currPerson.msn }}</span></li>
                  <li v-if="currPerson.homeCountry || currPerson.homeProvince || currPerson.homeCity || currPerson.homeStreet"><span
                      class="title">{{$t("wm_lang_html_afcb3b")}}</span><span
                      class="tex">{{ currPerson.homeCountry }}{{ currPerson.homeProvince }}{{ currPerson.homeCity }}{{
                      currPerson.homeStreet
                    }}</span>
                  </li>
                  <li v-if="currPerson.homePostalCode"><span
                      class="title">{{$t("wm_lang_html_8f5c40")}}</span><span>{{ currPerson.homePostalCode }}</span></li>
                  <li v-if="currPerson.memo"><span class="title">{{$t("wm_lang_html_751ce6")}}</span><span class="tex">{{ currPerson.memo }}</span></li>
                </ul>
                <ul v-if="$store.getters.currAddressType === 'org'">
                  <div v-show="currPerson.type !== 4">
                    <li class="name">{{ currPerson.name }}</li>
                    <!--<li><span>{{$t("wm_lang_html_f6d477")}}</span><span>{{currPerson.company}}</span></li>-->
                    <li v-if="currPerson.departName"><span class="title">{{$t("wm_lang_html_3593a5")}}</span><span class="tex">{{ currPerson.departName }}</span>
                    </li>
                    <li v-if="currPerson.position"><span class="title">{{$t("wm_lang_html_2d76b9")}}</span><span class="tex">{{ currPerson.position }}</span></li>
                    <li v-if="currPerson.mobile"><span class="title">{{$t("wm_lang_html_6b0d50")}}</span><span class="tex">{{ currPerson.mobile }}</span></li>
                    <li v-if="currPerson.tel"><span class="title">{{$t("wm_lang_html_5751bf")}}</span><span class="tex">{{ currPerson.tel }}</span></li>
                    <li v-if="currPerson.fax"><span class="title">{{$t("wm_lang_html_76b8e6")}}</span><span class="tex">{{ currPerson.fax }}</span></li>
                    <li v-if="currPerson.email"><span class="title">{{$t("wm_lang_html_da4495")}}</span><span class="tex">{{ currPerson.email }}</span></li>
                    <li v-if="currPerson.employeeId"><span class="title">{{$t("wm_lang_html_27dfde")}}</span><span
                        class="tex">{{ currPerson.employeeId }}</span></li>
                  </div>
                  <div v-show="currPerson.type === 4" class="address_part4">
                    <div class="name">{{ currPerson.name }}</div>
                    <!-- <div class="email">{{currPerson.email}}</div> -->
                    <!-- <div class="flexCenter mb30">{{currMaillist.includeDepartments}}</div> -->
                    <div class="p10-p0 line">
                      <span class="title">{{$t("wm_lang_html_d7405e")}}</span>
                      <div class="mail-list">
                        {{ currPerson.email }}
                      </div>
                    </div>
                    <div class="p10-p0 line">
                      <span class="title">{{$t("wm_lang_html_f03d42")}}</span>
                      <ul class="mail-list">
                        <li v-for="(item, index) in currMaillist.includeMembers" :key="index">{{ item }}<em>,</em></li>
                      </ul>
                    </div>
                    <div class="p10-p0 line">
                      <span class="title">{{$t("wm_lang_html_919466")}}</span>
                      <ul class="mail-list">
                        <li v-for="(item, index) in currMaillist.includeDepartments" :key="index">{{ item }}<em>,</em></li>
                      </ul>
                    </div>
                    <div class="p10-p0 line">
                      <span class="title">{{$t("wm_lang_html_49f15f")}}</span>
                      <ul class="mail-list">
                        <li v-for="(item, index) in currMaillist.nestList" :key="index">{{ item }}<em>,</em></li>
                      </ul>
                    </div>
                  </div>
                </ul>
                <!--<el-button size="small" type="primary" @click="toWrite(currPerson.email)">{{$t("wm_lang_html_e9e805")}}</el-button>-->
              </div>
            </div>
          </div>
        </div>
        <CustomConfirm
            :visible="deletePersonDiaVis"
            :title="$i18n.t('wm_lang_c45357')"
            :isShowClose="true"
            :isShowDes="true"
            :content="$i18n.t('wm_lang_9dcd1b')"
            @confirmCustomDialog="confirmDelPerson"
            customType="confirmDelPerson"
        ></CustomConfirm>
        <CustomConfirm
            :visible="deleteGroupDiaVis"
            :title="$i18n.t('wm_lang_c45357')"
            :isShowClose="true"
            :isShowDes="true"
            :content="$i18n.t('wm_lang_a4c993')"
            @confirmCustomDialog="confirmDelGroup"
            @changeGroupDelType="changeGroupDelType"
            customType="confirmDelGroup"
        ></CustomConfirm>
        <!-- 右侧页签 -->
        <!--<tabBar></tabBar>-->
      </div>
      <!--<app-footer></app-footer>-->
    </el-container>
  </el-container>
  <!--</div>-->
  <!--</el-container>-->
  <!--</div>-->
</template>

<script>
import AppHeader from '@/components/sub/Header.vue'
import AppFooter from '@/components/sub/Footer.vue'
import xmail from '@/api/api'
import CustomConfirm from '@/components/sub/customConfirm'
import request from '@/utils/request';
import storeLocal from 'store';
import _ from "lodash";
import TreeUtil from "../../core/tree/TreeUtil";
import TreeView from '../../core/tree/TreeView.vue';
import NewGroupDialog from '../../sub/newGroupDialog.vue';
import OrgContacts from "../../core/common/OrgContacts";
import DialogHandle from "../../../utils/dialogHandle";
import {downloadFile, bitIs1} from '@/utils/utils';
import BaseContactTree from "../../core/common/BaseContactTree";
import dragHolder from "@/components/sub/dragHolder";

export default {
    name: 'layoutMainAddress',
    mixins: [BaseContactTree],
    data() {
        let validateWorkAddress = (rule, value, callback) => {
            if ((this.persForm.workCountry && this.persForm.workCountry.length > 128)
                || (this.persForm.workProvince && this.persForm.workProvince.length > 128)
                || (this.persForm.workCity && this.persForm.workCity.length > 128)
                || (this.persForm.workStreet && this.persForm.workStreet.length > 128)
            ) {
                callback(new Error(this.$i18n.t('wm_lang_0c686f')+'128'));
            } else {
                callback();
            }
        };
        let validateHomeAddress = (rule, value, callback) => {
            if ((this.persForm.homeCountry && this.persForm.homeCountry.length > 128)
                || (this.persForm.homeProvince && this.persForm.homeProvince.length > 128)
                || (this.persForm.homeCity && this.persForm.homeCity.length > 128)
                || (this.persForm.homeStreet && this.persForm.homeStreet.length > 128)
            ) {
                callback(new Error(this.$i18n.t('wm_lang_0c686f')+'128'));
            } else {
                callback();
            }
        };
        return {
            currDepartGroup: {id: "persRoot", name: this.$i18n.t('wm_lang_d3298c')},
            contactListArr: [],
            deletePersonDiaVis: false,
            deleteGroupDiaVis: false,
            presGroupArr: [], // 组信息
            selectedGroupArr: [], //新建联系人已选的分组（直接绑定persForm.groupIds UI组件报错）
            checkedGroupArr: [],
            totalCount: 0,
            currPerson: {},
            currMaillist: {
                includeDepartments: [],
                includeMembers: [],
                nestList: []
            },
            confDisplaySetting: {},
            pageNumbers: [],
            userContactFileMax: 100,
            userContactMemberMax: 3,
            totalPages: 1, // 统共页数，默认为1
            currentPage: 1, //当前页数 ，默认为1
            pageSize: 20, // 每页显示数量
            currentListData: [], //当前页显示内容
            dialogFormVisible: false,
            formLabelWidth: '80px',
            dragWidth: 330,
            showCreateContact: false,
            showImport: false,
            showImportDetail: false,
            completelyDeleteGroup: false,
            displaySearch: false,
            currSearchKey: '',
            csvFileList: [],
            csvFile: null,
            importTableData: [],
            importDetailForm: {
                imGroup: '',
                imFileName: '',
                charset: '',
                matchField: []
            },
            persForm: {},
            personObj: {
                givenName: '',
                emails: [
                    {
                        value: ''
                    }
                ],
                telephones: [
                    {
                        value: ''
                    }
                ],
                faxs: [
                    {
                        value: ''
                    }
                ],
                groupIds: [],
                company: '',
                departName: '',
                position: '',
                workWebsite: '',
                workCountry: '',
                workProvince: '',
                workCity: '',
                workStreet: '',
                workPostalCode: '',
                nickname: '',
                gender: '',
                birthday: '',
                qq: '',
                wechat: '',
                msn: '',
                homeCountry: '',
                homeProvince: '',
                homeCity: '',
                homeStreet: '',
                homePostalCode: '',
                // personalRemark: [
                //   {
                //     value: ''
                //   }
                // ],
                memo: ''
            },
            rules: {
                workAddress: [{validator: validateWorkAddress, trigger: 'blur'}],
                homeAddress: [{validator: validateHomeAddress, trigger: 'blur'}],
            },
            /* Tree  Aside左侧导航 */
            addressTree: [],
            defaultProps: {
                children: 'children',
                label: 'name',
                type: 'type'
            },
            allListCheckBox: false,
            listSortType: 'def',
            contactTreeOption: {hiddenLeaf: true}
        }
    },
    components: {
        DialogHandle,
        'app-header': AppHeader,
        'app-footer': AppFooter,
        TreeView,
        NewGroupDialog,
        CustomConfirm,
        dragHolder
    },
    create() {
        // this.persForm = {...this.personObj}
    },
    methods: {
        // handleClick(tab, event) {
        //   console.log(tab, event);
        // },
        // handleNodeClick(data) {
        //   let listArr = [];
        //   this.createList(data, listArr);
        //   console.log(listArr)
        //   this.contactListArr = listArr;
        //   this.currDepartGroup = data.name;
        //   this.totalCount = listArr.length;
        // },
        dragWidthChange(moveDistance) {
            this.dragWidth -= moveDistance;
            if (this.dragWidth < 300) {
                this.dragWidth = 300;
            }
            if (this.dragWidth > 680) {
                this.dragWidth = 680;
            }
        },
        toTop() {
            this.$nextTick(() => {
                document.getElementById("addAddressWrapper").scrollTop = 0;
            });
        },
        fieldToTop() {
            this.$nextTick(() => {
                document.getElementById("importFieldWrapper").scrollTop = 0;
            });
        },
        emailVerify(email, index) {
            let emails = this.persForm.emails.filter((item, i, arr) => {
                return item.email && (item.value === email)
            });
            if (emails.length > 1) {
                this.$message({
                    type: 'info',
                    message: `${email}${this.$i18n.t('custom_lang_0009')}`
                });
            }
            // 仅判断第一个
            if (index === 0) {
                let self = this;
                let pm = { email };
                if (this.$store.getters.personOperType !== 'create') {
                    pm.userContactId = self.currPerson.userContactId;
                }
                (function (api, enums, pms) {
                    api.UserContact.detectMainEmail(pm, function(res) {
                        if(res.data.data.isExist) {
                            self.$message({
                                type: "warning",
                                message: `${this.$i18n.t('custom_lang_0010')}${email}${this.$i18n.t('custom_lang_0011')}`
                            });
                        }
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            }
        },
        deletePerson() {
            if (this.currDepartGroup.id === 'def' || this.currDepartGroup.id === 'persRoot') {
                this.$confirm(`<p>${this.$i18n.t("wm_lang_html_738bc9")}</p><p style="color:#999999; font-size: 12px">${this.$i18n.t("wm_lang_html_98f89e")}</p>`, this.$i18n.t('wm_lang_c45357'), {
                    confirmButtonText: this.$i18n.t('wm_lang_2f4aad'),
                    cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
                    closeOnClickModal: false,
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                }).then(() => {
                    let self = this;
                    (function (api, enums, pms) {
                        let persons = self.$store.getters.checkedAddress;
                        let pm = pms.UserContact.delUserContactInfoParamBuilder();
                        pm.groupId = self.currDepartGroup.id;
                        pm.userContactIds = persons.map(item => {
                            return item.id
                        });
                        pm.onlyOutGroup = false;
                        // console.log(pm)
                        // return;
                        api.UserContact.delUserContactInfo(pm, function (res) {
                            // console.log(res);
                            self.initPagePers();
                            // self.$refs.newGroupDialog.persTreeInit();
                            self.$message({
                                type: 'success',
                                message: self.$i18n.t('wm_lang_0007d1')+'!'
                            });
                        })
                    })(xmail.api, xmail.enums, xmail.pms);
                }).catch(() => {
                    // this.$message({
                    //   type: 'info',
                    //   message: this.$i18n.t('wm_lang_c34281')
                    // });
                });
            } else {
                this.deletePersonDiaVis = true;
            }
        },
        confirmDelGroup(type) {
            console.log(type)
            if (type === 'cancel') {
                this.deleteGroupDiaVis = false;
                return;
            }
            this.deleteGroupDiaVis = false;
            let self = this;
            (function (api, enums, pms) {
                let delFlag = self.completelyDeleteGroup;
                let pm = pms.UserContact.delUserContactGroupParamBuilder();
                pm.groupId = self.currDepartGroup.id;
                pm.thoroughDelFlag = delFlag;
                // console.log(pm)
                // return;
                api.UserContact.delUserContactGroup(pm, function (res) {
                    // console.log(res);
                    self.initPagePers();
                    // self.$refs.newGroupDialog.persTreeInit();
                    self.$message({
                        type: 'success',
                        message: self.$i18n.t('wm_lang_0007d1')+'!'
                    });
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        confirmDelPerson(type) {
            if (type === 'cancel') {
                this.deletePersonDiaVis = false;
                return;
            }
            let deleteType = false;
            if (type === 'confim2') {
                deleteType = true
            }
            this.deletePersonDiaVis = false;
            let self = this;
            (function (api, enums, pms) {
                let persons = self.$store.getters.checkedAddress;
                let pm = pms.UserContact.delUserContactInfoParamBuilder();
                pm.groupId = self.currDepartGroup.id;
                pm.userContactIds = persons.map(item => {
                    return item.id
                });
                pm.onlyOutGroup = deleteType;
                // console.log(pm)
                // return;
                api.UserContact.delUserContactInfo(pm, function (res) {
                    console.log(res);
                    self.initPagePers();
                    // self.$refs.newGroupDialog.persTreeInit();
                    self.$message({
                        type: 'success',
                        message: self.$i18n.t('wm_lang_0007d1')+'!'
                    });
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        createGroup() {
            this.dialogFormVisible = true;
            this.$store.commit('SET_GROUPOPERTYPE', 'add');
            this.$refs.newGroupDialog.groupOperAdd();
        },
        editGroup() {
            if (this.currDepartGroup.parent) {
                if (this.currDepartGroup.id === 'def') {
                    return;
                }
                this.dialogFormVisible = true;
                this.$store.commit('SET_GROUPOPERTYPE', 'edit');
                this.$refs.newGroupDialog.groupOperEdit();
            }
        },
        changeGroupDelType(e) {
            this.completelyDeleteGroup = e.target.checked
        },
        deleteGroup() {
            if (this.currDepartGroup.parent) {
                if (this.currDepartGroup.id === 'def') {
                    return;
                }
                this.deleteGroupDiaVis = true;
            }
        },
        addrImport() {
            this.showImport = true;
            this.importDetailForm.imGroup = 'def';
        },
        csvUpload(item) {
            this.csvFile = item.file
        },
        handleBeforeUpload(file) {
            if (file.name.split('.').pop().toLowerCase() !== 'csv' || file.size > this.userContactFileMax * 1024) {
                this.$message({
                    type: 'warning',
                    message: `${this.$i18n.t('custom_lang_0012')}${this.userContactFileMax}kb`
                });
                return false;
            }
        },
        handleRemove(file, fileList) {
            this.csvFile = null;
        },
        handleExceed(files, csvFileList) {
            // this.$message.warning(`每次只能导入 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + csvFileList.length} 个文件`);
            this.$message.warning(this.$i18n.t('wm_lang_b33403')+' 1 '+this.$i18n.t('wm_lang_fcbb1f'));
        },
        addrExport() {
            let urlParams = storeLocal.get('Pwm-urlParams');
            let pm = {};
            pm.exportType = xmail.enums.ExportType.CSV;
            pm.groupId = this.$store.getters.currGroupData ? this.$store.getters.currGroupData.id : 'def';
            let groupName = this.$store.getters.currGroupData ? this.$store.getters.currGroupData.name : this.$i18n.t('wm_lang_d3298c');
            let chkPersons = this.$store.getters.checkedAddress;
            pm.userContactIds = chkPersons.map(obj => {
                return obj.id
            });
            // console.log(pm);
            // return;
            let tipsTxt = '';
            if (pm.userContactIds.length === 0) {
                tipsTxt = `“${groupName}”`;
            } else {
                tipsTxt = this.$i18n.t('wm_lang_96900d');
            }
            this.$confirm(`${this.$i18n.t('custom_lang_0013')}${tipsTxt}${this.$i18n.t('custom_lang_0014')}`, this.$i18n.t('wm_lang_c45357'), {
                confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
                cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
                closeOnClickModal: false,
                type: 'warning'
            }).then(() => {
                let url = '/xmail/wm/v1/user/contact/exportContactUser' + urlParams;
                // downloadFile(url, pm, 'addressBook.csv');
                downloadFile(url, pm);
            }).catch(() => {
                //
            });
        },
        toWrite() {
            let chkPersons = this.$store.getters.checkedAddress;
            let chkPersonEmails = chkPersons.map(obj => {
                if (obj.email !== '') {
                    if (obj.name !== '') {
                        return `"${obj.name}"<${obj.email}>`;
                    } else {
                        return obj.email
                    }
                } else {
                    return obj.email
                }
            });
            let emails = chkPersonEmails.join(',');
            this.$router.push({name: 'write', params: {type: 'write', addr: emails}});
        },
        changeAddPm(pmObj) {
            let changedPm = {...pmObj};
            // console.log(changedPm)
            let emailArr = [];
            changedPm.emails.map((item) => {
                if (item.value !== '') {
                    emailArr.push(item.value)
                }
            });
            // changedPm.email = emailArr.join('§');
            changedPm.email = emailArr;
            delete changedPm.emails;
            let telArr = [];
            changedPm.telephones.map((item) => {
                if (item.value !== '') {
                    telArr.push(item.value)
                }
            });
            // changedPm.telephone = telArr.join('§');
            changedPm.telephone = telArr;
            delete changedPm.telephones;
            let faxArr = [];
            changedPm.faxs.map((item) => {
                if (item.value !== '') {
                    faxArr.push(item.value)
                }
            });
            // changedPm.fax = faxArr.join('§');
            changedPm.fax = faxArr;
            delete changedPm.faxs;
            // console.log(changedPm)
            changedPm.groupIds = this.selectedGroupArr;
            delete changedPm.groups;
            return changedPm;
        },
        submitFormAdd(formName) {
            //填写邮箱重复
            if (this.persForm.emails.length > 0) {
                let contactEmails = _.compact(this.persForm.emails.map(item => item.value));
                if (_.uniq(contactEmails).length !== contactEmails.length) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_86988e')+'!'
                    });
                    return;
                }
                if (_.uniq(contactEmails).length > this.userContactMemberMax) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_21cf5e') + this.userContactMemberMax
                    });
                    return;
                }
            }
            if (this.persForm.telephones.length > 0) {
                let contactTelephones = _.compact(this.persForm.telephones.map(item => item.value));
                if (_.uniq(contactTelephones).length !== contactTelephones.length) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_20601f')+'!'
                    });
                    return;
                }
                if (_.uniq(contactTelephones).length > this.userContactMemberMax) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_eb0ef8') + this.userContactMemberMax
                    });
                    return;
                }
            }
            if (this.persForm.faxs.length > 0) {
                let contactFaxs = _.compact(this.persForm.faxs.map(item => item.value));
                if (_.uniq(contactFaxs).length !== contactFaxs.length) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_517f89')+'!'
                    });
                    return;
                }
                if (_.uniq(contactFaxs).length > this.userContactMemberMax) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_c2460e') + this.userContactMemberMax
                    });
                    return;
                }
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.$store.getters.personOperType === 'create') {
                        //邮箱在个人通讯录中已存在()
                        let persInfoEmails = storeLocal.get('ls_pers_info').map(item => {
                            return item.email
                        });
                        persInfoEmails = persInfoEmails.filter(item => {
                            return item
                        });//剔除email为空
                        // console.log(persInfoEmails);
                        // console.log(this.persForm.emails);
                        let repeatEmail = '';
                        if (persInfoEmails.includes(this.persForm.emails[0].value)) {
                            repeatEmail = this.persForm.emails[0].value;
                        }
                        if (repeatEmail) {
                            this.$message({
                                type: 'warning',
                                message: `${this.$i18n.t('custom_lang_0010')}${repeatEmail}${this.$i18n.t('custom_lang_0011')}`
                            });
                            return;
                        }
                        let self = this;
                        (function (api, enums, pms) {
                            // let pm = pms.UserContact.addUserContactInfoParamBuilder();
                            // pm.userContactId = ite.id;
                            let pm = self.changeAddPm(self.persForm);
                            let fieldFilled = false;
                            let pmValues = Object.values(pm);
                            pmValues.forEach(item => {
                                if (typeof item === 'string') {
                                    if (item !== '') {
                                        fieldFilled = true;
                                    }
                                }
                                if (Array.isArray(item)) {
                                    if (item.length > 0) {
                                        fieldFilled = true;
                                    }
                                }
                            });
                            if (!fieldFilled) {
                                self.$message({
                                    type: "warning",
                                    message: self.$i18n.t('wm_lang_b2fbc1')
                                });
                                return;
                            }
                            // console.log(pm)
                            // return;
                            api.UserContact.addUserContactInfo(pm, function (res) {
                                // console.log(res);
                                if (res.data.code === 0) {
                                    self.$message({
                                        type: 'success',
                                        message: self.$i18n.t('wm_lang_3fdaea')+'!'
                                    });
                                    self.initPagePers();
                                    self.$store.commit('SET_CURRADDRESSTYPE', 'pers');
                                    // self.$refs.newGroupDialog.persTreeInit();
                                    self.goBack();
                                }
                            })
                        })(xmail.api, xmail.enums, xmail.pms);
                    } else {
                        let self = this;
                        (function (api, enums, pms) {
                            let pm = self.changeAddPm(self.persForm);
                            let fieldFilled = false;
                            let pmValues = Object.values(pm);
                            // console.log(pmValues)
                            pmValues.forEach(item => {
                                if (item !== self.persForm.userContactId) {
                                    if (typeof item === 'string') {
                                        if (item !== '') {
                                            fieldFilled = true;
                                        }
                                    }
                                    if (Array.isArray(item)) {
                                        if (item.length > 0) {
                                            fieldFilled = true;
                                        }
                                    }
                                }
                            });
                            if (!fieldFilled) {
                                self.$message({
                                    type: "warning",
                                    message: self.$i18n.t('wm_lang_b2fbc1')
                                });
                                return;
                            } else {
                                pm.userContactId = self.currPerson.userContactId;
                            }
                            // console.log(pm)
                            // return;
                            api.UserContact.updateUserContactInfo(pm, function (res) {
                                console.log(res);
                                if (res.data.code === 0) {
                                    self.$message({
                                        type: 'success',
                                        message: self.$i18n.t('wm_lang_3bb47b')+'!'
                                    });
                                }
                                self.initPagePers();
                                // self.$refs.newGroupDialog.persTreeInit();
                                self.goBack();
                            })
                        })(xmail.api, xmail.enums, xmail.pms);
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetFormAdd(formName) {
            this.$refs[formName].resetFields();
            this.persForm.workCountry = '';
            this.persForm.workProvince = '';
            this.persForm.workCity = '';
            this.persForm.workStreet = '';
            this.persForm.homeCountry = '';
            this.persForm.homeProvince = '';
            this.persForm.homeCity = '';
            this.persForm.homeStreet = '';
            this.selectedGroupArr = [];
        },
        submitFormImport(formName) {
            // console.log(this.csvFile);
            if (this.csvFile === null) {
                this.$message({
                    type: 'warning',
                    message: this.$i18n.t('wm_lang_1e328f')
                });
                return;
            }

            this.showImportDetail = true;
            this.showImport = false;

            let urlParams = storeLocal.get('Pwm-urlParams');
            let formData = new FormData();
            formData.append('file', this.csvFile);
            formData.append('charset', 'GB18030');
            // formData.append('charset','UTF-8');
            request({
                url: '/xmail/wm/v1/user/contact/uploadContactUserFile' + urlParams,
                method: 'post',
                data: formData
            }).then(res => {
                this.importTableData = res.data.data.headerResults;
                this.importDetailForm.imFileName = res.data.data.fileName;
            });
            this.fieldToTop();
        },
        changeFileCode() {
            // console.log(this.importDetailForm.charset)
            // return;
            let urlParams = storeLocal.get('Pwm-urlParams');
            let charset = this.importDetailForm.charset ? this.importDetailForm.charset : 'GB18030';
            let formData = new FormData();
            formData.append('file', this.csvFile);
            formData.append('charset', charset);
            request({
                url: '/xmail/wm/v1/user/contact/uploadContactUserFile' + urlParams,
                method: 'post',
                data: formData
            }).then(res => {
                this.importTableData = res.data.data.headerResults;
                this.importDetailForm.imFileName = res.data.data.fileName;
            });
        },
        cancelFormImport(formName) {
            // this.$refs[formName].resetFields();
            this.$refs.csvUploader.clearFiles();
            this.csvFile = null;
            this.showImport = false;
        },
        submitFormImportDetail(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //
                    console.log(this.importDetailForm.matchField)
                    if (this.importDetailForm.matchField.length === 0) {
                        this.$message({
                            type: 'warning',
                            message: this.$i18n.t('wm_lang_650b9f')
                        });
                        return;
                    }
                    let pm = _.invertBy(this.importDetailForm.matchField); //键值反转
                    pm = _.omit(pm, [undefined, '']);//剔除未选字段及选择了‘请选择’的字段
                    let fieldValidFlag = true;
                    let self = this;
                    _.forEach(pm, function (value, key) {//多选字段数组构建&字段对应条件验证
                        console.log(value);
                        console.log(key);
                        if (key !== 'email' && key !== 'telephone' && key !== 'fax') {
                            if (value.length > 1) {
                                fieldValidFlag = false;
                                return;
                            } else {
                                pm[key] = value[0];
                            }
                        }
                    });
                    if (!fieldValidFlag) {
                        self.$message({
                            type: 'info',
                            message: self.$i18n.t('wm_lang_a0db8e')
                        });
                        return;
                    }
                    pm.fileName = this.importDetailForm.imFileName;
                    pm.groupId = this.importDetailForm.imGroup;
                    pm.charset = this.importDetailForm.charset;
                    //后端接口要求没有电话传真邮件参数时传空数组
                    if (!pm.telephone) {
                        pm.telephone = [];
                    }
                    if (!pm.fax) {
                        pm.fax = [];
                    }
                    if (!pm.email) {
                        pm.email = [];
                    }
                    // console.log(pm)
                    // return;
                    (function (api, enums, pms) {
                        api.UserContact.importContactUser(pm, function (res) {
                            // console.log(res)
                            if (res.data.code === 0) {
                                self.$message({
                                    type: 'success',
                                    message: self.$i18n.t('wm_lang_b6d16a')
                                });
                                self.initPagePers();
                                // self.$refs.newGroupDialog.persTreeInit();
                            } else {
                                /*self.$message({
                                    type: 'error',
                                    message: res.data.msg ? res.data.msg : this.$i18n.t('wm_lang_fddcd7')
                                })*/
                            }
                            self.goBack();
                            self.importDetailForm = {
                                imGroup: '',
                                imFileName: '',
                                charset: '',
                                matchField: []
                            }
                        })
                    })(xmail.api, xmail.enums, xmail.pms);
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        cancelFormImportDetail(formName) {
            this.$refs[formName].resetFields();
            this.$refs.csvUploader.clearFiles();
            this.showImportDetail = false;
            this.showImport = true;
            this.csvFile = null;
            this.importDetailForm = {
                imGroup: '',
                imFileName: '',
                charset: '',
                matchField: []
            }
        },
        removeEmail(item) {
            let index = this.persForm.emails.indexOf(item)
            if (index !== -1) {
                this.persForm.emails.splice(index, 1)
            }
        },
        addEmail() {
            if (this.persForm.emails.length >= 30) {
                this.$message({
                    type: 'warning',
                    message: this.$i18n.t('wm_lang_af3c66')+'30'+this.$i18n.t('wm_lang_930882')
                });
                return;
            }
            this.persForm.emails.push({
                value: '',
                key: Date.now()
            });
        },
        removeTelephone(item) {
            let index = this.persForm.telephones.indexOf(item)
            if (index !== -1) {
                this.persForm.telephones.splice(index, 1)
            }
        },
        addTelephone() {
            if (this.persForm.telephones.length >= 30) {
                this.$message({
                    type: 'warning',
                    message: this.$i18n.t('wm_lang_b09b04')+'30'+this.$i18n.t('wm_lang_930882')
                });
                return;
            }
            this.persForm.telephones.push({
                value: '',
                key: Date.now()
            });
        },
        removeFax(item) {
            let index = this.persForm.faxs.indexOf(item)
            if (index !== -1) {
                this.persForm.faxs.splice(index, 1)
            }
        },
        addFax() {
            if (this.persForm.faxs.length >= 30) {
                this.$message({
                    type: 'warning',
                    message: this.$i18n.t('wm_lang_f35fae')+'30'+this.$i18n.t('wm_lang_930882')
                });
                return;
            }
            this.persForm.faxs.push({
                value: '',
                key: Date.now()
            });
        },
        // removePersonalRemark(item) {
        //   let index = this.persForm.personalRemark.indexOf(item)
        //   if (index !== -1) {
        //     this.persForm.personalRemark.splice(index, 1)
        //   }
        // },
        // addPersonalRemark() {
        //   this.persForm.personalRemark.push({
        //     value: '',
        //     key: Date.now()
        //   });
        // },
        nodeClickOrg(data) {
            this.displaySearch = false;
            this.currentPage = 1;
            this.handleNodeClick(data);
            this.$store.commit('SET_CURRADDRESSTYPE', 'org');
            this.allListCheckBox = false;
            //this.listSortType = 'all';
        },
        nodeClickPers(data) {
            this.displaySearch = false;
            this.currentPage = 1;
            this.handleNodeClick(data);
            this.$store.commit('SET_CURRADDRESSTYPE', 'pers');
            this.allListCheckBox = false;
            //this.listSortType = 'all';
        },
        handleNodeClick(data) {
            console.log(data)
            this.goBack();
            this.$store.commit('SET_CHECKED_ADDRESS', []);
            this.$store.commit('SET_CURRGROUPDATA', data);
            this.contactListArr = this.createContactList(data);
            this.currDepartGroup = data;
            // this.totalCount = listArr.length;
            this.filterContact(this.listSortType);
        },
        checkedItem(id) {
            let chkAddress = this.$store.getters.checkedAddress;
            if (chkAddress) {
                let chkAddressIds = chkAddress.map(obj => {
                    return obj.id
                })
                return chkAddressIds.includes(id);
            }
        },
        cancelGroupDialog() {
            this.dialogFormVisible = false;
        },
        getGroupAddData(persons, group) {
            // console.log(persons)
            // console.log(group)
            if (!group) {
                this.$message({
                    type: 'warning',
                    message: this.$i18n.t('wm_lang_2b9bad')
                });
                return;
            }

            if (group.length > this.configSetting.globalConfig.fieldLengthLimit.userContactLimit.givenName) {
                this.$message({
                    type: 'warning',
                    message: `${this.$i18n.t('custom_lang_0015')}${this.configSetting.globalConfig.fieldLengthLimit.userContactLimit.givenName}${this.$i18n.t('custom_lang_0016')}`
                });
                return;
            }
            if (this.$store.getters.groupOperType === 'add') {
                let self = this;
                (function (api, enums, pms) {
                    let pm = pms.UserContact.addUserContactGroupParamBuilder();
                    pm.name = group;
                    pm.userContactIds = persons.map(item => {
                        return item.id
                    });
                    // console.log(pm)
                    // return;
                    api.UserContact.addUserContactGroup(pm, function (res) {
                        // console.log(res);
                        if (res.data.code === 0) {
                            self.$message({
                                type: 'success',
                                message: self.$i18n.t('wm_lang_3fdaea')
                            });
                        }
                        self.initPagePers();
                        // self.$refs.newGroupDialog.persTreeInit();
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            } else {
                let self = this;
                (function (api, enums, pms) {
                    let pm = pms.UserContact.updateUserContactGroupParamBuilder();
                    pm.userGroupId = self.$store.getters.currGroupData.id
                    pm.name = group;
                    pm.userContactIds = persons.map(item => {
                        return item.id
                    });
                    // console.log(pm)
                    // return;
                    api.UserContact.updateUserContactGroup(pm, function (res) {
                        // console.log(res);
                        if (res.data.code === 0) {
                            self.$message({
                                type: 'success',
                                message: self.$i18n.t('wm_lang_69be67')
                            });
                        }
                        self.initPagePers();
                        // self.$refs.newGroupDialog.persTreeInit();
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            }
            this.cancelGroupDialog();
        },
        checkedGroup(id) {
            let chkGroups = this.checkedGroupArr;
            let chkGroupIds = chkGroups.map(obj => {
                return obj.id
            })
            return chkGroupIds.includes(id);
        },
        selectGroup(e, item) {
            // this.checkedGroupArr.push(item);
            if (this.checkedGroupArr.includes(item)) {
                this.checkedGroupArr.splice(this.checkedGroupArr.findIndex(ite => ite.id === item.id), 1)
            } else {
                this.checkedGroupArr.push(item);
            }
        },
        applyGroup() {
            let chkGroups = this.checkedGroupArr;
            let chkGroupIds = chkGroups.map(obj => {
                return obj.id
            });
            let chkPersons = this.$store.getters.checkedAddress;
            let chkPersonIds = chkPersons.map(obj => {
                return obj.id
            });
            if (chkGroups.length === 0) {
                this.$message({
                    type: 'warning',
                    message: this.$i18n.t('wm_lang_9c3c31')
                });
                return;
            }
            let self = this;
            (function (api, enums, pms) {
                let pm = pms.UserContact.addToNewGroupParamBuilder();
                pm.newGroupIds = chkGroupIds;
                pm.userContactIds = chkPersonIds;
                api.UserContact.addToNewGroup(pm, function (res) {
                    console.log(res);
                    self.checkedGroupArr = [];
                    self.initPagePers();
                    // self.$refs.newGroupDialog.persTreeInit();
                    self.$message({
                        type: 'success',
                        message: self.$i18n.t('wm_lang_6a5aa0')+'!'
                    });
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        goBack() {
            // this.toTop();
            this.showCreateContact = false;
            this.showImport = false;
            this.showImportDetail = false;
            this.cancelFormImport();
        },
        goPrev() {
            this.showImport = true;
            this.showImportDetail = false;
            this.importDetailForm = {
                imGroup: '',
                imFileName: '',
                charset: '',
                matchField: []
            }
        },
        selectIndexList(type) {
            let checkedIndex = this.$store.getters.checkedAddress;
            let checkedIndexIds = checkedIndex.map(item => {
                return item.id
            });
            let indexList = this.$store.getters.indexListAddress;
            let tempList = [];
            switch (type) {
                case 'all':
                    tempList = indexList.map(item => {
                        return item
                    })
                    return tempList;
                    break;
                case 'reverse':
                    tempList = indexList.filter(item => !checkedIndexIds.includes(item.id))
                    return tempList;
                    break;
                default:
                    return;
            }
        },
        // 数组对象方法排序
        sortByKey(array, key, sortType, withSortVal) {
            return array.sort(function (a, b) {
                if (withSortVal && 'number' === typeof a.sortVal && 'number' === typeof b.sortVal && a.sortVal !== b.sortVal) {
                    return b.sortVal - a.sortVal;
                }
                let x = ('' + a[key]).replace(/([a-z]|[A-Z])/g, "9$&");
                let y = ('' + b[key]).replace(/([a-z]|[A-Z])/g, "9$&");
                if (sortType === 'asc') {
                    return x.localeCompare(y, 'zh', {sensitivity: 'variant'}); //((x < y) ? -1 : ((x < y) ? 1 : 0));
                }
                if (sortType === 'desc') {
                    return y.localeCompare(x, 'zh', {sensitivity: 'variant'}); //((x > y) ? -1 : ((x > y) ? 1 : 0));
                }
            });
        },
        filterContact(type) {
            this.listSortType = type;
            switch (type) {
                case 'nameAsc':
                    this.contactListArr = this.sortByKey(this.contactListArr, 'name', 'asc', false);
                    break;
                case 'nameDesc':
                    this.contactListArr = this.sortByKey(this.contactListArr, 'name', 'desc', false);
                    break;
                case 'addrAsc':
                    this.contactListArr = this.sortByKey(this.contactListArr, 'email', 'asc', false);
                    break;
                case 'addrDesc':
                    this.contactListArr = this.sortByKey(this.contactListArr, 'email', 'desc', false);
                    break;
                default:
                    this.listSortType = 'def'
                    this.contactListArr = this.sortByKey(this.contactListArr, 'name', 'asc', true);
                    break;
            }
            this.currentPage = 1;
            this.setCurrentPageData();
            this.setPagesData();
        },
        allSelect() {
            this.$store.commit('SET_CHECKED_ADDRESS', this.selectIndexList('all'));
        },
        reverseSelect() {
            this.$store.commit('SET_CHECKED_ADDRESS', this.selectIndexList('reverse'));
        },
        notSelect() {
            this.$store.commit('SET_CHECKED_ADDRESS', []);
        },
        handleAllChecked(e) {
            if (e.target.checked) {
                this.allSelect();
            } else {
                this.notSelect();
            }
        },
        stopBubble(e) {
            e.stopPropagation();
        },
        checkedCommand(command) {
            switch (command) {
                case 'all':
                    this.allSelect();
                    break;
                case 'reverse':
                    this.reverseSelect();
                    break;
                case 'not':
                    this.notSelect();
                    break;
                default:
                    return;
            }
            this.allListCheckBox = this.$store.getters.checkedAddress.length === this.pageSize
        },
        getDepartsLabel(node) {
            let label = "";
            if (typeof node.parent !== "undefined") {
                let parentLabel = this.getDepartsLabel(node.parent)
                label = ("" === parentLabel ? '' : parentLabel + '/') + node.name;
            }
            return label;
        },
        handleCheckedMailChange(e, item) {
            let chkAddress = this.$store.getters.checkedAddress;
            console.log(chkAddress)
            if (e.target.checked) {
                chkAddress.push(item);
                if (chkAddress.length < 2) {
                    console.log(item)
                    this.toReadContact(item);
                }
            } else {
                chkAddress.splice(chkAddress.findIndex(ite => ite.id === item.id), 1)
                if (chkAddress.length < 1) {
                    return
                }
                if (chkAddress.length < 2) {
                    this.toReadContact(chkAddress[0]);
                }
            }
            this.allListCheckBox = this.$store.getters.checkedAddress.length === this.pageSize;
            // console.log(chkAddress)
            this.$store.commit('SET_CHECKED_ADDRESS', chkAddress)
        },
        toReadContact(ite) {
            // console.log(ite);
            //选中当前联系人加入已选
            this.$store.commit('SET_CHECKED_ADDRESS', []); //点击联系人清空复选索引
            this.allListCheckBox = this.$store.getters.checkedAddress.length === this.pageSize;
            let indexAddress = this.$store.getters.indexListAddress;
            let chkAddress = this.$store.getters.checkedAddress;
            // console.log(indexAddress);
            let currAddr = indexAddress.find(item => item.id === ite.id);
            chkAddress.push(currAddr);
            this.$store.commit('SET_CHECKED_ADDRESS', chkAddress);
            //读取联系人详情
            let self = this;
            if (self.$store.getters.currAddressType === 'pers') {
                (function (api, enums, pms) {
                    let pm = pms.UserContact.getUserContactInfoParamBuilder();
                    pm.userContactId = ite.id;
                    api.UserContact.getUserContactInfo(pm, function (res) {
                        // console.log(res)
                        // let resData = new pms.GetUserContactInfoResult(res.data.data);
                        if (res.data.code === 0) {
                            self.currPerson = res.data.data;
                            console.log(self.$store.getters.checkedAddress)
                        }
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            } else {
                let currPers = self.$store.getters.checkedAddress;
                currPers = currPers.map(({name, position, tel, mobile, fax, email, employeeId, type}) => ({
                    name,
                    position,
                    tel,
                    mobile,
                    fax,
                    email,
                    employeeId,
                    type
                }));
                self.currPerson = currPers[0]; //组织结构联系人从tree数据中取联系人详细信息
                // console.log(self.currPerson);
                if (self.currPerson.type === 1) { //组织结构
                    self.currPerson.departName = self.getDepartsLabel(ite.parent ? ite.parent : {});
                    (function (api, enums, pms) {
                        let pm = pms.CorpContact.queryUserInfoParamBuilder();
                        pm.corpContactId = ite.id;
                        api.CorpContact.queryUserInfo(pm, function (res) {
                            console.log(res)
                            // let resData = new pms.GetUserContactInfoResult(res.data.data);
                            let resData = res.data.data;
                            for (let key in resData) { //补足tree数据中缺少的属性值
                                // console.log(key)
                                // console.log(self.currPerson[key])
                                // console.log(resData[key])
                                if (!self.currPerson[key]) {
                                    self.currPerson[key] = resData[key]
                                }
                            }
                            // self.currPerson = resData;
                            // console.log(self.$store.getters.checkedAddress)
                        })
                    })(xmail.api, xmail.enums, xmail.pms);
                }
                if (self.currPerson.type === 3) { //外部联系人
                    self.currPerson.departName = self.getDepartsLabel(ite.parent ? ite.parent : {});
                    (function (api, enums, pms) {
                        let pm = pms.CorpContact.queryCorpContactInfoParamBuilder();
                        pm.corpContactId = ite.id;
                        api.CorpContact.queryCorpContactInfo(pm, function (res) {
                            console.log(res)
                            // let resData = new pms.GetUserContactInfoResult(res.data.data);
                            let resData = res.data.data;
                            for (let key in resData) { //补足tree数据中缺少的属性值
                                // console.log(key)
                                // console.log(self.currPerson[key])
                                // console.log(resData[key])
                                if (!self.currPerson[key]) {
                                    self.currPerson[key] = resData[key]
                                }
                            }
                            // self.currPerson = resData;
                            // console.log(self.$store.getters.checkedAddress)
                        })
                    })(xmail.api, xmail.enums, xmail.pms);
                }
                if (self.currPerson.type === 4) { //邮件列表
                    (function (api, enums, pms) {
                        let pm = pms.CorpContact.queryEmailListParamBuilder();
                        pm.corpContactId = ite.email;
                        api.CorpContact.queryEmailList(pm, function (res) {
                            // console.log(res);
                            let resData = res.data.data;
                            self.currMaillist.includeDepartments = resData.includeDepartments;
                            self.currMaillist.includeMembers = resData.includeMembers;
                            self.currMaillist.nestList = resData.nestList;
                        })
                    })(xmail.api, xmail.enums, xmail.pms);
                }
            }
        },
        createContact(addr) {
            //新建联系人
            //@params addr {name, email}
            // this.persForm = {...this.personObj};
            // console.log(typeof addr);
            this.selectedGroupArr = [];
            this.persForm = JSON.parse(JSON.stringify(this.personObj))
            this.showCreateContact = true;
            this.showImport = false;
            this.showImportDetail = false;
            if (addr && addr.email) {
                this.persForm.givenName = addr.name;
                let tempEmail = [];
                tempEmail.push({value: addr.email});
                this.persForm.emails = tempEmail;
            }
            this.$store.commit('SET_PERSONOPERTYPE', 'create');
            this.toTop();
        },
        editContact() {
            //编辑联系人
            // console.log(this.currPerson);
            this.showCreateContact = true;
            this.$store.commit('SET_PERSONOPERTYPE', 'edit');
            this.toTop();
            this.selectedGroupArr = [];
            if (this.currPerson) {
                let filterObj = {...this.currPerson};
                let tempEmails = [];
                if (filterObj.emails.length > 0) {
                    filterObj.emails.map((item) => {
                        tempEmails.push({value: item})
                    });
                } else {
                    tempEmails.push({value: ''})
                }
                filterObj.emails = tempEmails;
                let tempTelephones = [];
                if (filterObj.telephones.length > 0) {
                    filterObj.telephones.map((item) => {
                        tempTelephones.push({value: item})
                    });
                } else {
                    tempTelephones.push({value: ''})
                }
                filterObj.telephones = tempTelephones;
                let tempFaxs = [];
                if (filterObj.faxs.length > 0) {
                    filterObj.faxs.map((item) => {
                        tempFaxs.push({value: item})
                    });
                } else {
                    tempFaxs.push({value: ''})
                }
                filterObj.faxs = tempFaxs;
                filterObj.groups.map((item) => {
                    this.selectedGroupArr.push(item.groupId);
                });
                this.persForm = filterObj;
            }
        },
        createContactList(root) {
            let listArr = [];
            this.createList(root, listArr);
            //去重
            if ('persRoot' === root.id) {
                let obj = {};
                return listArr.reduce((cur, next) => {
                    obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
                    return cur;
                }, [])
            }
            return listArr;
        },
        createList(addrs, listArr) {
            if (!Array.isArray(addrs.children) || addrs.children.length === 0 || addrs.hidden) {
                return
            }
            addrs.children.map(item => {
                if (item.children && item.children.length !== 0) {
                    this.createList(item, listArr)
                }
                if (xmail.enums.OrgTreeNodeType.USER === item.type ||
                    xmail.enums.OrgTreeNodeType.CONTACT_INFO === item.type ||
                    xmail.enums.OrgTreeNodeType.MAILLIST_ACCOUNT === item.type) {
                    listArr.push(item)
                }
            })
        },
        makePageNumbers(total) {
            let pNumbers = [];
            for (let i = 0; i < total; i++) {
                let item = {c: i + 1, t: total}
                pNumbers.push(item);
            }
            return pNumbers;
        },
        getTurnPrevFlag() {
            let flag = false;
            if (this.currentPage === 1) {
                flag = true
            }
            return flag
        },
        getTurnNextFlag() {
            let flag = false;
            if (this.currentPage === this.totalPages) {
                flag = true
            }
            return flag
        },
        handlePageTurn(command) {
            this.currentPage = command;
            let begin = (command - 1) * this.pageSize;
            let end = command * this.pageSize;
            this.currentListData = this.contactListArr.slice(begin, end);
        },
        setPagesData() {
            // 计算总页数
            this.totalPages = Math.ceil(this.contactListArr.length / this.pageSize);
            // 不足一页
            this.totalPages = this.totalPages === 0 ? 1 : this.totalPages;
            // 分页数据
            this.pageNumbers = this.makePageNumbers(this.totalPages);
        },
        // 设置当前页面数据，截取规则为[0-10],[10-20]
        setCurrentPageData() {
            let begin = (this.currentPage - 1) * this.pageSize;
            let end = this.currentPage * this.pageSize;
            this.totalCount = this.contactListArr.length;
            this.currentListData = this.contactListArr.slice(begin, end);
            this.$store.commit('SET_INDEX_ADDRESS', this.currentListData);
            // console.log(this.$store.getters.indexListAddress)
        },
        //上一页
        prevPage() {
            console.log(this.currentPage);
            if (this.currentPage === 1) return;
            this.currentPage--;
            this.setCurrentPageData();
        },
        // 下一页
        nextPage() {
            if (this.currentPage === this.totalPages) return;
            this.currentPage++;
            this.setCurrentPageData();
        },
        getOrgTrees(nodes) {
            if (!this.persAddressPriv) {
                this.currDepartGroup = {id: "orgRoot", name: this.$i18n.t('wm_lang_d43e13')};
                this.contactListArr = this.createContactList(nodes[0]);
                this.filterContact(this.listSortType);
            }
        },
        getPersTrees(nodes) {
            if (!this.persAddressPriv) {
                return;
            }
            //初始化个人通讯录索引
            this.initPersIndexList(nodes[0]);
            //提取组数据
            this.presGroupArr = nodes[0].children.filter(item => item.type === 2);
        },
        initPersIndexList(treeRoot) {
            /*初始化通讯录索引*/
            this.contactListArr = this.createContactList(treeRoot);

            // self.currDepartGroup = this.$i18n.t('wm_lang_a8b0c2');
            // this.totalCount = allListArr.length;
            /*分页*/
            this.filterContact(this.listSortType);
        },
        initSearchPersIndexList(searchResult) {
            /*个人搜索结果索引*/
            this.displaySearch = true;
            this.contactListArr = searchResult;
            this.currDepartGroup = {id: "searchRoot", name: this.$i18n.t('wm_lang_6d37b4')};
            this.totalCount = searchResult.length;
            this.$store.commit('SET_CHECKED_ADDRESS', []);
            /*分页*/
            this.filterContact(this.listSortType);
        },
        initSearchOrgIndexList(searchResult) {
            /*组织搜索结果索引*/
            // console.log(searchResult)
            this.displaySearch = true;
            this.contactListArr = searchResult;
            this.currDepartGroup = {id: "root", name: this.$i18n.t('wm_lang_6a23f1')};
            this.totalCount = searchResult.length;
            this.$store.commit('SET_CHECKED_ADDRESS', []);
            /*分页*/
            this.filterContact(this.listSortType);
        },
        persInfoMap(persNodes) {
            let persInfo = persNodes[0].children ? persNodes[0].children : [];
            storeLocal.set('ls_pers_info', persInfo);
        },
        initPagePers() {
            this.$store.commit('SET_PERS_FRESH', false);
            this.$store.commit('SET_CHECKED_ADDRESS', []);
            this.currDepartGroup = {id: "persRoot", name: this.$i18n.t('wm_lang_d3298c')};
            //获取个人通讯录数据，并初始化tree
            let self = this;
            let persVersion = this.$store.getters.persVersion;
            OrgContacts.getPersAddressTrees(function (nodes) {
                // console.log(nodes);
                if (!nodes) {
                    return;
                }
                let perVer = nodes.contactVersion;
                let persNodes = [];
                if (!nodes.versionChange) {
                    persNodes = storeLocal.get('ls_pers_address') ? storeLocal.get('ls_pers_address') : self.$store.getters.persAddress;
                } else {
                    persNodes = nodes.userContactTrees;
                    self.$store.commit('SET_PERS_VERSION', perVer);
                    try {
                        storeLocal.set('ls_pers_address', persNodes);
                    } catch (e) {
                        self.$store.commit('SET_PERS_ADDRESS', persNodes);
                    }
                }
                const persTree = JSON.stringify(persNodes);
                self.initPersTree(JSON.parse(persTree));
                self.persInfoMap(JSON.parse(persTree));
                self.$refs.newGroupDialog.newGroupPersTrees(JSON.parse(persTree));
            }, persVersion);
        },
        searchResultList(addrs, key, listArr) {
            addrs.map(item => {
                if (item.type !== 2) {
                    if ((item.name && item.name.includes(key))
                        || (item.email && item.email.includes(key))
                        || (item.position && item.position.includes(key))
                        || (item.tel && item.tel.includes(key))
                        || (item.mobile && item.mobile.includes(key))) {
                        listArr.push(item)
                    }
                }
                if (item.hidden) {
                    return;
                }
                if (item.children && item.children.length !== 0) {
                    this.searchResultList(item.children, key, listArr)
                }
            })
        }
    },
    computed: {
        selectedAddress() {
            return this.$store.getters.checkedAddress.length
        },
        currAddressType() {
            return this.$store.getters.currAddressType
        },
        displayGroup() {
            let group = [];
            let groupStr = '';
            if (this.currPerson.groups && this.currPerson.groups.length > 0) {
                this.currPerson.groups.forEach((item, index) => {
                    // console.log(item)
                    group.push(item.groupName)
                })
            }
            groupStr = group.toString() !== '' ? group.toString() : '';
            return groupStr;
        }
    },
    watch: {
        $route(to) {
            // console.log(to);
            if (this.$route.params.headerGo) {
                this.showCreateContact = false;
                this.showImport = false;
                this.showImportDetail = false;
                this.allListCheckBox = false;
                this.$store.commit('SET_CHECKED_ADDRESS', []);
            }
            // 其他模块直接跳转至联系人添加页
            if (this.$route.params.type && this.$route.params.type === 'addAddr') {
                this.createContact(this.$route.params.addr);
            }
            if (this.$route.params.type && this.$route.params.type === 'editAddr') {
                // this.createContact(this.$route.params.addr);
                let persInfo = storeLocal.get('ls_pers_info') ? storeLocal.get('ls_pers_info') : [];
                // console.log(persInfo);
                let currPer = persInfo.find(item => {
                    return item.email === this.$route.params.addr.email
                });
                let self = this;
                (function (api, enums, pms) {
                    let pm = pms.UserContact.getUserContactInfoParamBuilder();
                    pm.userContactId = currPer.id;
                    api.UserContact.getUserContactInfo(pm, function (res) {
                        // console.log(res)
                        if (res.data.code === 0) {
                            self.currPerson = res.data.data;
                            self.editContact();
                        }
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            }
            //开启了自动加入通信，发信后刷新个人通讯录
            if(to.name === 'address') {
                if(this.$store.getters.persTreeFresh) {
                    this.initPagePers();
                }
            }
        }
    },
    mounted() {
        this.confDisplaySetting = this.configSetting.displaySetting;
        this.userContactFileMax = this.configSetting.globalConfig.maximumLimit.userContactFileMax;
        this.userContactMemberMax = this.configSetting.globalConfig.maximumLimit.userContactMemberMax;
        let self = this;
        //搜索组织结构
        this.$EventBus.$off("searchOrgAddrResult");
        this.$EventBus.$on("searchOrgAddrResult", function (key) {
            self.currSearchKey = key;
            let orgNodes = self.orgTrees;
            if (!orgNodes) {
                orgNodes = storeLocal.get('ls_org_address') ? storeLocal.get('ls_org_address') : self.$store.getters.orgAddress;
            }
            let listArr = [];
            // console.log(orgNodes);
            self.searchResultList(orgNodes, key, listArr);
            self.initSearchOrgIndexList(listArr);
            // console.log(listArr);
            self.$store.commit('SET_CURRADDRESSTYPE', 'org');
        });
        //搜索个人通讯录
        this.$EventBus.$off("searchPersAddrResult");
        this.$EventBus.$on("searchPersAddrResult", function (key) {
            self.currSearchKey = key;
            (function (api, enums, pms) {
                let pm = pms.UserContact.searchUserContactParamBuilder();
                pm.keyWords = key;
                api.UserContact.searchUserContact(pm, function (res) {
                    // console.log(res.data.data);
                    //显示搜索联系人结果
                    self.initSearchPersIndexList(res.data.data);
                    self.$store.commit('SET_CURRADDRESSTYPE', 'pers');
                })
            })(xmail.api, xmail.enums, xmail.pms);
        });

        // 其他模块直接跳转至联系人添加页
        if (this.$route.params.type && this.$route.params.type === 'addAddr') {
            this.createContact(this.$route.params.addr);
        }
        if (this.$route.params.type && this.$route.params.type === 'editAddr') {
            // this.createContact(this.$route.params.addr);
            let persInfo = storeLocal.get('ls_pers_info') ? storeLocal.get('ls_pers_info') : [];
            // console.log(persInfo);
            let currPer = persInfo.find(item => {
                return item.email === this.$route.params.addr.email
            });
            let self = this;
            (function (api, enums, pms) {
                let pm = pms.UserContact.getUserContactInfoParamBuilder();
                pm.userContactId = currPer.id;
                api.UserContact.getUserContactInfo(pm, function (res) {
                    // console.log(res)
                    if (res.data.code === 0) {
                        self.currPerson = res.data.data;
                        self.editContact();
                    }
                })
            })(xmail.api, xmail.enums, xmail.pms);
        }
        // 初始化个人通讯录
        this.initPagePers();
    }
}
</script>

<style scoped>
.wmCloudsWrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
}

/deep/ .address-cont {
    padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/layout/MainAddress.vue